import React, { useState, useRef, useEffect } from "react";

// Reusable component that accepts any list of items and supports reordering
const AnimatedReorderList = ({ items, onItemsChange, itemRenderer, id }) => {
  const [localItems, setLocalItems] = useState(items);
  const animatingRef = useRef(false);

  const moveItem = (index, direction) => {
    if (animatingRef.current) return;
    animatingRef.current = true;

    const newItems = [...localItems];
    const elements = document.querySelectorAll('.list-item');
    const itemHeight = elements[index].offsetHeight + 8; // Adding gap of 8px

    const animateMove = (element1, element2, offset) => {
      element1.style.transform = 'translateY(0)';
      element2.style.transform = 'translateY(0)';
      element1.style.transition = 'transform 0.3s ease-in-out';
      element2.style.transition = 'transform 0.3s ease-in-out';

      // Force reflow to reset the positions
      void element1.offsetHeight;

      // Animate move
      element1.style.transform = `translateY(${offset}px)`;
      element2.style.transform = `translateY(${-offset}px)`;
    };

    const updateItemsAfterMove = (newOrder) => {
      setTimeout(() => {
        onItemsChange(newOrder);
        setLocalItems(newOrder);

        // Reset styles after animation
        const elements = document.querySelectorAll('.list-item');
        elements.forEach((el) => {
          el.style.transform = '';
          el.style.transition = '';
        });

        animatingRef.current = false;
      }, 300);
    };

    if (direction === 'up' && index > 0) {
      const element1 = elements[index];
      const element2 = elements[index - 1];
      animateMove(element1, element2, -itemHeight);

      [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]];
      updateItemsAfterMove(newItems);
    } else if (direction === 'down' && index < localItems.length - 1) {
      const element1 = elements[index];
      const element2 = elements[index + 1];
      animateMove(element1, element2, itemHeight);

      [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
      updateItemsAfterMove(newItems);
    }
  };

  useEffect(() => {
    setLocalItems(items)
  }, [items])

  return (
    <div className="max-w-md mx-auto ">
      <ul className="">
        {localItems.map((item, index) => (
          <li
            style={{ listStyle: "none" }}
            key={item[id] || item}
            className="list-item bg-white shadow-md rounded-lg  flex items-center justify-between"
          >
            <div className="flex-1">
              {itemRenderer(item, index, moveItem)}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AnimatedReorderList;
